// This file was automatically generated from appchart.dialog.order.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.dialog.order');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.order.testCenterSites = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<option value="" selected>none</option>');
  var cList1685 = opt_data.choices;
  var cListLen1685 = cList1685.length;
  for (var cIndex1685 = 0; cIndex1685 < cListLen1685; cIndex1685++) {
    var cData1685 = cList1685[cIndex1685];
    output.append('<option value="', soy.$$escapeHtml(cData1685.id), '">', soy.$$escapeHtml(cData1685.locationName), '</option>');
  }
  if (!opt_sb) return output.toString();
};
